import { faCreditCardAlt } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { Horizontal } from 'atoms/layout/flex';
import { BodyM } from 'atoms/typography';
import { PaymentMethodIcon } from 'components/paymentMethods/Icon';

export const NewCreditCard = () => {
  return (
    <Horizontal gap={1}>
      <PaymentMethodIcon icon={faCreditCardAlt} />
      <BodyM color="var(--c-white)">
        <FormattedMessage
          id="NewPaymentBox.methods.newCreditCard"
          defaultMessage="New credit card"
        />
      </BodyM>
    </Horizontal>
  );
};
